import { upperFirst } from 'lodash-es';

import { isDefined } from '../../type-guards';

/**
 * Giving a first and last name, return a formatted full name.
 *
 * @param {string} firstName First name
 * @param {string} lastName Last name
 * @param {string} fallback To return if both firstName and lastName are falsy
 * @returns {string} Formatted full name or fallback, if both firstName and lastName are falsy
 */
export const formatName = (firstName?: string | null, lastName?: string | null, fallback = '-'): string => {
  if (!firstName && !lastName) return fallback;
  return [firstName, lastName].filter(isDefined).map(upperFirst).join(' ');
};
